import { TextField } from "@mui/material";
import styles from "../../../../propertydetails.module.css";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import NumberFormat from "react-number-format";
import * as yup from "yup";
import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { AddLogCallAPI } from "../../../../../../components/AddLogs";
import { toast } from "react-smart-toaster";

function CurrencyField(props) {
    return (<NumberFormat customInput={TextField} prefix="$" displayType="input" type="text" inputMode="decimal" isNumericString={true} thousandSeparator={true} allowNegative={false} decimalScale={2} fixedDecimalScale={true} variant="outlined" fullWidth {...props} />);
}

const priceSchema = (label) => yup.string()
    .required(label + " is required")
    .matches(/^\d+(\.\d{1,2})?$/, "Enter a valid amount")
    .test("min-1", label + " must be at least $1.00", (value) => parseFloat(value) >= 1)
    .test("max-9999", label + " can not be more than $9,999.99", (value) => parseFloat(value) < 10000);

const schema = yup.object().shape({
    guest_day_pass_price: priceSchema("Day pass price"),
    guest_monthly_pass_price: priceSchema("Monthly pass price"),
});

const GuestParkingPassSettings = ({ guest_day_pass_price, guest_monthly_pass_price, setLoading, setSnackbarMsg, setSnackbarOpen, setPropertyData, property_name, property_id }) => {
    const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();
    const { handleSubmit, control, errors, setValue } = useForm({
        shouldUnregister: false,
        resolver: yupResolver(schema),
        defaultValues: {
            guest_day_pass_price: "",
            guest_monthly_pass_price: "",
        },
    });

    useEffect(() => {
        if (guest_day_pass_price !== null && typeof guest_day_pass_price !== "undefined") {
            setValue('guest_day_pass_price', String(guest_day_pass_price));
        }
        if (guest_monthly_pass_price !== null && typeof guest_monthly_pass_price !== "undefined") {
            setValue('guest_monthly_pass_price', String(guest_monthly_pass_price));
        }
    }, [guest_day_pass_price, guest_monthly_pass_price, setValue])

    const onSubmit = async (data) => {
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        setLoading(true);
        const postData = {
            guest_day_pass_price: parseFloat(data.guest_day_pass_price),
            guest_monthly_pass_price: parseFloat(data.guest_monthly_pass_price),
        };
        return axios.put(process.env.REACT_APP_PROPERTY_API_URL + "v1/properties/" + property_id + "/update-guest-parking-pass", postData, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            setPropertyData((prev) => {
                return { ...prev, guest_day_pass_price: response.data?.data?.guest_day_pass_price, guest_monthly_pass_price: response.data?.data?.guest_monthly_pass_price };
            });

            let logData = {
                title: "Guest parking pass settings updated",
                description: ["Property: " + property_name],
            };
            AddLogCallAPI(logData, token);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<form onSubmit={handleSubmit(onSubmit)}>
        <div style={{ maxWidth: "300px" }}>
            <div className={`${styles.FormRow}`}>
                <div className={`${styles.FormGroupFullPay} FormGroup`}>
                    <Controller
                        name={`guest_day_pass_price`}
                        control={control}
                        render={(field) => (
                            <CurrencyField
                                value={field.value}
                                onValueChange={(values) => field.onChange(values.value)}
                                onBlur={field.onBlur}
                                label="Day Pass Price ($)*"
                                error={!!errors.guest_day_pass_price}
                                helperText={errors?.guest_day_pass_price?.message || "Valid for 24 hours"}
                            />)}
                    />
                </div>
            </div>

            <div className={`${styles.FormRow}`}>
                <div className={`${styles.FormGroupFullPay} FormGroup`}>
                    <Controller
                        name={`guest_monthly_pass_price`}
                        control={control}
                        render={(field) => (
                            <CurrencyField
                                value={field.value}
                                onValueChange={(values) => field.onChange(values.value)}
                                onBlur={field.onBlur}
                                label="Monthly Pass Price ($)*"
                                error={!!errors.guest_monthly_pass_price}
                                helperText={errors?.guest_monthly_pass_price?.message || "Valid for 30 days"}
                            />)}
                    />
                </div>
            </div>

            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("property-settings:update") > -1 && <div>
                <button type="submit" className={`${styles.ButtonVoiletSolid}`}>Update</button>
            </div>}
        </div>
    </form>)
}

export default GuestParkingPassSettings;
